/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { instance2 } from "../../utils/axiosInstance";
import { formatNumber } from "../../numberingformat";
import CalendarIcon from "../../img/calendaricon.svg";
import { jsPDF } from "jspdf"; // Import jsPDF for PDF generation
import "jspdf-autotable"; // Import the autotable plugin for jsPDF
import DapurIcon from "../../img/logodapursidebar.png";
import { basecode } from "./baserobotocode";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import isEqual from 'lodash/isEqual';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import { ChevronLeft, ChevronRight, Plus } from "lucide-react";
import { Button } from "../../shadcn/button";
import { useMediaQuery } from "src/lib/hooks";


export default function PenerimaanPO() {
  
    // Access state from the navigate call
    const location = useLocation();
  
    const isDesktop = useMediaQuery("(min-width: 1024px)");
    // Extract startDate and endDate from the URL query string
    const queryParams = new URLSearchParams(location.search);
    const startDate = queryParams.get('startDate');
    const endDate = queryParams.get('endDate');
    const dateParam = queryParams.get('dateParam');


  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [dataReceived, setDataReceived] = useState([]);  
  const [deliveryOrder, setDeliveryOrder] = useState([]);
  const [deliveryOrderExist, setDeliveryOrderExist] = useState([]);
  const [filteredDataReceived, setFilteredDataReceived] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
 // const [selectedDate, setSelectedDate] = useState(new Date());
  const [isOpen, setIsOpen] = useState(false);
  const [sortSupplier, setSortSupplier] = useState(""); // For filtering by supplier
  const [sortIngredient, setSortIngredient] = useState(""); // For filtering by ingredient
    const [sortDate, setSortDate] = useState(""); // For filtering by ingredient
    const navigate = useNavigate()
    //const [username, setUsername] = useState(""); // For filtering by ingredient


    const locationId = localStorage?.getItem("locationId")
    const storedUsername = localStorage.getItem("userAuthentication");
    const kitchenId = parseInt(localStorage.getItem("kitchenId"),10);
 const [submitting, setSubmitting] = useState(false);
 const [submitted, setSubmitted] = useState(false);

const roleId = parseInt(localStorage.getItem('roleId'),10); 


  const [rowDropdownValues, setRowDropdownValues] = useState({});
  
  const [tableColumnDefaults, setTableColumnDefaults] = useState({});

  
  const prevDropdownValues = useRef({}); // to store previous values and prevent redundant updates


  // UseEffect to update `rowDropdownValues` when `data` or `tableColumnDefaults` change
  useEffect(() => {
    setRowDropdownValues((prev) => {
      const updatedValues = { ...prev };
      let isUpdated = false; // Track if any value has been updated

      // Loop through the data and apply the column defaults if needed
      data.forEach((row) => {
        // If the column (timeliness) was not modified by the user, update to default
        if (updatedValues[row.key]?.timeliness === undefined) {
          updatedValues[row.key] = {
            ...updatedValues[row.key],
            timeliness: tableColumnDefaults[row.key]?.timeliness || '', // Set default value for timeliness
          };
          isUpdated = true;
        }

        // If the column (quality) was not modified by the user, update to default
        if (updatedValues[row.key]?.quality === undefined) {
          updatedValues[row.key] = {
            ...updatedValues[row.key],
            quality: tableColumnDefaults[row.key]?.quality || '', // Set default value for quality
          };
          isUpdated = true;
        }
      });

      // Only update state if there's a change in the updatedValues
      if (isUpdated && !areEqual(prevDropdownValues.current, updatedValues)) {
        prevDropdownValues.current = updatedValues; // Store updated state in ref
        return updatedValues; // Return updated values to set the state
      } else {
        return prev; // If no change, return previous state to avoid unnecessary updates
      }
    });
  }, []); // This effect runs when `data` or `tableColumnDefaults` changes

  // Function to deep compare objects (you can replace this with lodash.isEqual or another method)
  const areEqual = (obj1, obj2) => {
    // Compare objects by stringifying them
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  };


    
  const timelinessDropdown = {
    id: "timeliness",
    label: "Tepat Waktu",
    options: [
      { id: "5", label: "Tepat Waktu" },
      { id: "3", label: "Agak Terlambat" },
      { id: "1", label: "Terlambat" },
    ],
  };
  
  const qualityDropdown = {
    id: "quality",
    label: "Kualitas",
    options: [
      { id: "5", label: "Baik" },
      { id: "3", label: "Sedang" },
      { id: "1", label: "Buruk" },
    ],
  };

    // Handle dropdown value change (user selecting a new value)
    const handleDropdownChange = (rowKey, column, value) => {
      setRowDropdownValues((prev) => ({
        ...prev,
        [rowKey]: { ...prev[rowKey], [column]: value }, // Update only the selected row
      }));
    };
  
    // Handle the change of the column default
    const handleColumnDefaultChange = (tableKey, columnId, value) => {
      setTableColumnDefaults((prev) => ({
        ...prev,
        [tableKey]: {
          ...prev[tableKey],
          [columnId]: value,
        },
      }));
    };

  
  const [editableRows, setEditableRows] = useState({}); // To track checkbox states
  const [selectAll, setSelectAll] = useState({}); // To track "select all" state per table
  
  // Handle "select all" toggle for a specific table
  const handleSelectAllChange = (orderNumber, deliveryDate, items) => {
    const tableKey = `${orderNumber}-${deliveryDate}`;
    const isAllSelected = !selectAll[tableKey];
  
    // Update the "select all" state
    setSelectAll((prev) => ({
      ...prev,
      [tableKey]: isAllSelected,
    }));
  
    // Update editable rows
    setEditableRows((prev) => {
      const updatedRows = { ...prev };
      items.forEach((item, idx) => {
        const rowKey = `${tableKey}-${idx}`;
        updatedRows[rowKey] = {
          ...updatedRows[rowKey],
          checked: isAllSelected,
          edited_qty: isAllSelected ? item.order_qty : 0,
        };
      });
      return updatedRows;
    });
  
    // ✅ Reset quality if unchecked
    if (!isAllSelected) {
      setRowDropdownValues((prev) => {
        const updated = { ...prev };
        items.forEach((_, idx) => {
          const rowKey = `${tableKey}-${idx}`;
          updated[rowKey] = {
            ...updated[rowKey],
            quality: "", // Clear quality
          };
        });
        return updated;
      });
    }
  };
  
  
  // Handle individual checkbox toggle
  const handleCheckboxChange = (orderNumber, deliveryDate, idx, value, items) => {
    const tableKey = `${orderNumber}-${deliveryDate}`;
    const uniqueKey = `${tableKey}-${idx}`;
    const isCurrentlyChecked = editableRows[uniqueKey]?.checked || false;
    const willBeChecked = !isCurrentlyChecked;
  
    setEditableRows((prev) => ({
      ...prev,
      [uniqueKey]: {
        ...prev[uniqueKey],
        checked: willBeChecked,
        edited_qty: willBeChecked ? value : 0,
      },
    }));
  
    // ✅ Reset quality dropdown if being unchecked
    if (!willBeChecked) {
      setRowDropdownValues((prev) => ({
        ...prev,
        [uniqueKey]: {
          ...prev[uniqueKey],
          quality: "", // reset to "Pilih Kualitas"
        },
      }));
    }
  
    // Update "Select All" status
    setSelectAll((prev) => {
      const updatedSelectAll = { ...prev };
      const allChecked = items.every((_, i) =>
        i === idx
          ? !editableRows[`${tableKey}-${i}`]?.checked
          : editableRows[`${tableKey}-${i}`]?.checked
      );
      updatedSelectAll[tableKey] = allChecked;
      return updatedSelectAll;
    });
  };
  
  
  // Handle order quantity changes
  const handleReceivedQtyChange = (orderNumber, deliveryDate, idx, value) => {
    const uniqueKey = `${orderNumber}-${deliveryDate}-${idx}`;
    const isQtyZero = value <= 0;
  
    setEditableRows((prev) => ({
      ...prev,
      [uniqueKey]: {
        ...prev[uniqueKey],
        edited_qty: value,
        checked: isQtyZero ? false : prev[uniqueKey]?.checked || false,
      },
    }));
  
    // Reset the dropdown value if quantity is 0 or less
    if (isQtyZero) {
      setRowDropdownValues((prev) => ({
        ...prev,
        [uniqueKey]: {
          ...prev[uniqueKey],
          quality: "", // Reset quality
        },
      }));
    }
  };
  
  const handlePenerimaan = async () => {
    navigate(`/penerimaanbahan?startDate=${dateParam}&endDate=${dateParam}`);
  };

  const handleDO = async () => {
    navigate(roleId===3 ? `/penerimaanbahan?startDate=${startDate}&endDate=${endDate}` : `/penerimaanbahansortbydapur?startDate=${startDate}&endDate=${endDate}`);
  };


const handlePenerimaanHarian = async () => {
  navigate(`/penerimaanbahan?startDate=${startDate}&endDate=${startDate}`);

};

const localDateString = (thedate) =>{

  const year = thedate.getFullYear();
  const month = String(thedate.getMonth() + 1).padStart(2, '0');  // Adding 1 because months are 0-based
  const day = String(thedate.getDate()).padStart(2, '0');
  
//console.log("startDate", thedate);
const localDateString = `${year}-${month}-${day}`;

return localDateString

}


const fetchData = async () => {
  try {
    setLoading(true);
    setError(null);
    
    const formattedStartDate = localDateString(new Date(startDate));
    const formattedEndDate = localDateString(new Date(endDate));

    const response = await instance2.post(`purchase_order`, {
      startdate: formattedStartDate,
      enddate: formattedEndDate,
    });
    
    const result = response.data?.data || response.data || [];
    
    // Only update state if data has changed
    if (JSON.stringify(result) !== JSON.stringify(data)) {
     const filtered = result.filter((item) => item.kitchen_id === kitchenId);

     setData(filtered);
      setFilteredData(filtered); // Initialize filtered data with full data
    }
  } catch (err) {
    setError(err.message || "Failed to fetch data");
  } finally {
    setLoading(false);
  }
  try {
    setLoading(true);
    setError(null);

    const formattedStartDate = localDateString(new Date(startDate));
    const formattedEndDate = localDateString(new Date(endDate));

    const response = await instance2.get(
      `order_received/location/${locationId}/${formattedStartDate}/${formattedEndDate}`
    );

    const result = response.data?.data || response.data || [];

    // Only update state if data has changed
    //if (JSON.stringify(result) !== JSON.stringify(dataReceived)) {
      setDataReceived(result);
      setFilteredDataReceived(result); // Initialize filtered data with full data
    //}
    
  } catch (err) {
    setError(err.message || "Failed to fetch data");
  } finally {
    setLoading(false);
  }

  try {
    setLoading(true);
    setError(null);

    const formattedStartDate = localDateString(new Date(startDate));
    const formattedEndDate = localDateString(new Date(endDate));

    const response = await instance2.get(
      `delivery_order/location/${locationId}/${localDateString(new Date(formattedStartDate))}/${localDateString(new Date(formattedEndDate))}`
    );

    const result = response.data ;

      setDeliveryOrder(result);
      setDeliveryOrderExist(result.length);
  } catch (err) {
    setError(err.message || "Failed to fetch data");
  } finally {
    setLoading(false);
  }
};



// Define useRef to track if data has already been fetched
//const dataFetched = useRef(false); // This will be used to track if data is fetched

// useEffect(() => {
//   // Prevent fetching data again if already fetched
//   //if (!dataFetched.current) {
//     fetchData();
//  // }
// }, []); // Re-run the effect only if startDate or endDate changes

  function rateTime(dataReceived, orderNumber, deliveryDate)  {

    const filteredData = dataReceived.filter(item => item.order_no === orderNumber );
    if(filteredData.length > 0) {
      console.log("date",localDateString(new Date(filteredData[0]?.date_request))|| "no")
      console.log("delivery", localDateString(new Date(deliveryDate)))
    console.log("order_no",filteredData[0]?.order_no)
    
    console.log("order",filteredData[0]?.rate_time)
    }
    return filteredData[0]?.rate_time;
  }

  // Function to compare and mark records in fetchData
  const compareData = () => {
    // Loop through each record in the fetched data and add a matched flag
    const updatedData = [...data]; // Copy data to avoid direct mutation
    const newDropdownValues = { ...rowDropdownValues };
  
    updatedData.forEach((record, index) => {
      const matchingRecord = dataReceived.find(
        (receivedRecord) =>
          receivedRecord.ingredient_id === record.ingredient_id &&
          receivedRecord.order_no === record.order_no &&
          receivedRecord.date_request === record.delivery_date
      );
  
      const tableKey = `${record.order_no}-${localDateString(new Date(record.delivery_date))}`;
      const rowKey = `${tableKey}-${index}`;
  
      if (matchingRecord) {
        updatedData[index] = {
          ...record,
          matched: true,
          receivedQty: matchingRecord.qty_received,
          rate_quality: matchingRecord.rate_quality,
          matchedData: matchingRecord,
        };
  
        // Pre-fill dropdowns for matched items
        newDropdownValues[tableKey] = {
          ...(newDropdownValues[tableKey] || {}),
          timeliness: matchingRecord.rate_time || "",
        };
        newDropdownValues[rowKey] = {
          ...(newDropdownValues[rowKey] || {}),
          quality: matchingRecord.rate_quality || "",
        };
      } else {
        updatedData[index] = {
          ...record,
          matched: false,
        };
      }
    });
  
    setData(updatedData);
    setRowDropdownValues(newDropdownValues);
  };
  

useEffect(() => {
  // Call the fetch functions only if the data hasn't been loaded yet
  if (data.length === 0 || dataReceived.length === 0 || deliveryOrderExist === 0) {
    fetchData();
    //fetchDataReceived();
    //fetchDeliveryOrder();
  }
}, [startDate, endDate]);  // Add dependencies to rerun when startDate or endDate changes


// After both fetchData and fetchDataReceived are completed, call compareData
const hasCompared = useRef(false);

useEffect(() => {
  if (data.length > 0 && dataReceived.length > 0 && !hasCompared.current) {
    compareData();
    hasCompared.current = true; // ✅ Prevents repeated execution
  }
}, [dataReceived]);

  const getWeekStartAndEndDates = (date) => {
    const current = new Date(date);
    const dayOfWeek = current.getDay();

    const monday = new Date(current);
    monday.setDate(current.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

    const friday = new Date(monday);
    const sunday = new Date(monday);
    friday.setDate(monday.getDate() + 4);
    sunday.setDate(monday.getDate() + 6);

    return { startDate: monday, endDate: sunday };
  };
  // Group data by Order Number, then by Delivery Date
  const groupDataByOrderNumberAndDeliveryDate = (data) => {
    return data.reduce((acc, item) => {
      if (!acc[item.order_no]) {
        acc[item.order_no] = {};
      }

      const deliveryDate = localDateString(new Date(item.delivery_date)); ; // Extract date part (YYYY-MM-DD)


      if (!acc[item.order_no][deliveryDate]) {
        acc[item.order_no][deliveryDate] = [];
      }

      acc[item.order_no][deliveryDate].push(item);

      return acc;
    }, {});
  };


  //oke
  // Sort the grouped data by delivery date
  const sortGroupedDataByDate = (groupedData) => {
    for (const orderNumber in groupedData) {
      const orderDetails = groupedData[orderNumber];

      // Sort the delivery dates within each order
      const sortedDeliveryDates = Object.keys(orderDetails).sort((a, b) => new Date(a) - new Date(b));

      // Rebuild the orderDetails object with sorted delivery dates
      const sortedOrderDetails = {};
      sortedDeliveryDates.forEach((deliveryDate) => {
        sortedOrderDetails[deliveryDate] = orderDetails[deliveryDate];
      });

      groupedData[orderNumber] = sortedOrderDetails;
    }

    return groupedData;
  };

  // Filter data when sortSupplier or sortIngredient changes
  useEffect(() => {
    let filtered = data;

    if (sortSupplier) {
      filtered = filtered.filter((item) => item.supplier_name === sortSupplier);
    }

    if (sortIngredient) {
      filtered = filtered.filter((item) => item.ingredient_name === sortIngredient);
    }

    if (sortDate) {
      filtered = filtered.filter((item) => item.delivery_date === sortDate);
    }

    setFilteredData(filtered);
  }, [sortSupplier, sortIngredient,sortDate, data]);

  // Function to generate grey color for each delivery date
  const generateGreyColor = (index) => {
    const shadesOfGrey = [
      "#e5e5e5", // lightest grey
    ];
    return shadesOfGrey[index % shadesOfGrey.length]; // Loop through shades
  };
  
  // Group the filtered data by Order Number and Delivery Date
  const groupedData = groupDataByOrderNumberAndDeliveryDate(filteredData);
  const sortedGroupedData = sortGroupedDataByDate(groupedData); // Sort the grouped data
  
  const handleDeliverySubmit = (deliveryDate, orderNumber, items) => {
    const dataToSubmitArray = [];
  
    items.forEach((item, index) => {
      const rowKey = `${orderNumber}-${deliveryDate}-${index}`;
      const tableKey = `${orderNumber}-${deliveryDate}`;
      const editedRow = editableRows[rowKey];
      const isMatched = item.matched;
  
      let dataToSubmit;
  
      if (isMatched) {
        // Submit matched item with backend values
        dataToSubmit = {
          order_detail_id: item.id,
          order_id: item.order_id,
          order_no: orderNumber,
          ingredient_id: item.ingredient_id,
          edited_qty: item.receivedQty,
          category_id: item.category_id,
          supplier_id: item.supplier_id,
          qty_request: item.order_qty,
          qty_received: item.receivedQty,
          date_received: localDateString(new Date(startDate)),
          date_request: localDateString(new Date(item.delivery_date)),
          rate_quality: item.rate_quality,
          rate_time: rateTime(filteredDataReceived, orderNumber, deliveryDate),
          rate_qty: item.receivedQty - item.order_qty >= 0
            ? 5
            : item.receivedQty - item.order_qty >= -10
            ? 3
            : 1,
          qty_difference: item.receivedQty - item.order_qty,
          admin_id: storedUsername || "",
          location_id: locationId,
          kitchen_id: kitchenId,
        };
      } else if (editedRow?.checked) {
        // Only submit if row is checked
        const editedQty = editedRow.edited_qty || 0;
        const rate_value = editedQty - item.order_qty >= 0
          ? 5
          : editedQty - item.order_qty >= -10
          ? 3
          : 1;
  
        const quality =
          rowDropdownValues[rowKey]?.quality ||
          tableColumnDefaults[tableKey]?.quality ||
          "";
  
        const timeliness =
          rowDropdownValues[tableKey]?.timeliness ||
          tableColumnDefaults[tableKey]?.timeliness ||
          "";
  
        if (!quality || !timeliness) return; // Guard against empty required fields
  
        dataToSubmit = {
          order_detail_id: item.id,
          order_id: item.order_id,
          order_no: orderNumber,
          ingredient_id: item.ingredient_id,
          edited_qty: editedQty,
          category_id: item.category_id,
          supplier_id: item.supplier_id,
          qty_request: item.order_qty,
          qty_received: editedQty,
          date_received: localDateString(new Date(startDate)),
          date_request: localDateString(new Date(item.delivery_date)),
          rate_quality: quality,
          rate_time: timeliness,
          rate_qty: rate_value,
          qty_difference: editedQty - item.order_qty,
          admin_id: storedUsername || "",
          location_id: locationId,
          kitchen_id: kitchenId,
        };
      }
  
      if (dataToSubmit) {
        dataToSubmitArray.push(dataToSubmit);
      }
    });
  
    if (dataToSubmitArray.length === 0) {
      alert("Tidak ada data yang dipilih untuk disimpan.");
      return;
    }
    if (dataToSubmitArray.length === 0) {
    alert("Tidak ada data yang dipilih untuk disimpan.");
    return;
  }

  setSubmitting(true); // ✅ show loading

  instance2
    .post("/order_received", dataToSubmitArray)
    .then((response) => {
      //alert("Penerimaan berhasil disimpan!");
      setData((prevData) =>
      prevData.map((item) => {
        const submitted = dataToSubmitArray.find(
          (x) => x.order_detail_id === item.id
        );
        return submitted
          ? { ...item, matched: true, receivedQty: submitted.qty_received }
          : item;
      })
    );
  setSubmitted(true); // ✅ show loading
    })
    .catch((error) => {
      console.error("Error submitting delivery:", error);
      alert("Gagal menyimpan penerimaan.");
    })
    .finally(() => {
      setSubmitting(false); // ✅ hide loading
    });
  };
  

// useEffect(() => {
//   const getNextMonday = () => {
//     const currentDate = new Date();
//     const dayOfWeek = currentDate.getDay();
//     const daysUntilNextMonday = (8 - dayOfWeek) % 7;
//     currentDate.setDate(currentDate.getDate() + daysUntilNextMonday);
//     currentDate.setHours(0, 0, 0, 0);
    
//     return currentDate;
//   };

  // If roleId is 2, set selected date to next Monday, else this week's Monday
 // setSelectedDate(roleId === 2 ? getNextMonday() : new Date());
// }, [roleId]);

  return (
    <div className="p-4">
      {/* Header */}
      {submitting && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg text-center">
      <p className="text-lg font-semibold mb-2">Menyimpan penerimaan...</p>
      <div className="w-10 h-10 border-4 border-gray-300 border-t-red-500 rounded-full animate-spin mx-auto"></div>
    </div>
  </div>
)}
      {submitted && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
  <div className="bg-white p-6 rounded-lg shadow-lg text-center">
    <p className="text-lg font-semibold mb-4">Tersimpan</p>
    
    <div className="flex justify-center">
      <Button
        className="bg-merah-no hover:bg-merah-hover text-white rounded-[50px] px-6 py-2"
        onClick={() => setSubmitted(false)}
      >
        Oke
      </Button>
    </div>
  </div>
</div>

)}

      <div className="flex flex-row w-full justify-between items-center">
        <div className="flex flex-col w-full">
          <p className="block text-black text-xl sm:text-2xl my-2 font-medium">Penerimaan Bahan Baku</p>
          <div className="pb-4">
            {(() => {
              //const { startDate, endDate } = getWeekStartAndEndDates(selectedDate);
              return `${new Date(startDate).toLocaleDateString("id-ID", {
                year: "numeric",
                month: "long",
                day: "2-digit",
              })} ` +
              `${startDate !== endDate ? "-" +  new Date(endDate).toLocaleDateString("id-ID", {
                year: "numeric",
                month: "long",
                day: "2-digit",
              }) : ""} `;
            })()}
          </div>
          <div className="border-t border-gray-400 w-full flex-1 mb-5"></div>
          <div className="flex flex-col md:flex-col lg:flex-row items-start md:items-start lg:items-center gap-4 justify-between w-full">
            {/* <div className="flex flex-row items-center gap-4 py-4">
              <div className="text-md">Tanggal</div>
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                dateFormat="yyyy-MM-dd"
                onCalendarOpen={() => setIsOpen(true)}
                onCalendarClose={() => setIsOpen(false)}
                customInput={<CustomInput isOpen={isOpen} />}
              />
            </div> */}
            <div className="flex gap-4 items-center">
              <label className="text-md text-black text-xxs md:text-xxs lg:text-base">Nama Pemasok</label>
              <select
                value={sortSupplier}
                onChange={(e) => setSortSupplier(e.target.value)}
                className="px-8 py-2 border-transparent rounded-[25px] text-xxs md:text-xxs lg:text-base"
              >
                <option value="">Semua</option>
                {[...new Set(data.map((item) => item.supplier_name))].map(
                  (supplier, index) => (
                    <option key={index} value={supplier}>
                      {supplier}
                    </option>
                  )
                )}
              </select>
            </div>
            
            <div className="flex gap-4 items-center">
              <label className="text-md text-black text-xxs md:text-xxs lg:text-base">Tanggal</label>
              <select
                value={sortDate}
                onChange={(e) => setSortDate(e.target.value)}
                className="px-8 py-2 border-transparent rounded-[25px] text-xxs md:text-xxs lg:text-base"
              >
                <option value="">Semua</option>
                {[...new Set(data.map((item) => item.delivery_date))].map(
                  (date, index) => (
                    <option key={index} value={date}>
                      {new Date(date).toLocaleDateString("id-ID", {
                        year: "numeric",
                        month: "long",
                        day: "2-digit",
                      })}
                    </option>
                  )
                )}
              </select>
            </div>

            {/* <div className="flex gap-4 items-center">
              <label className="text-md text-black">Nama Bahan</label>
              <select
                value={sortIngredient}
                onChange={(e) => setSortIngredient(e.target.value)}
                className="px-4 py-2 border-transparent rounded-[25px]"
              >
                <option value="">All</option>
                {[...new Set(data.map((item) => item.ingredient_name))].map(
                  (ingredient, index) => (
                    <option key={index} value={ingredient}>
                      {ingredient}
                    </option>
                  )
                )}
              </select>
            </div> */}
            <div className="flex gap-4 items-center">
          {roleId === 2  || roleId === 4 || roleId === 5 ? (
        <div className="w-full px-3 py-4 text-center">
            <button
              type="button"
              onClick={handleDO}
              className={deliveryOrderExist !== 0 ? "w-full px-8 py-4 text-white rounded-[50px] mx-4 bg-merah-no hover:bg-merah-hover uppercase" :
                "w-full px-8 py-4 text-white rounded-[50px] mx-4 bg-gray-200 uppercase"}
                disabled = {deliveryOrderExist === 0}
            >
               LIHAT DO
            </button>
            </div>
) : ("")}
{(roleId === 2 || roleId === 4 || roleId === 5) && (
  <div className="w-full px-3 py-4 text-center">
    <button
      type="button"
      onClick={handleDO}
      className={`w-full px-8 py-4 text-white rounded-[50px] mx-4 uppercase ${
        deliveryOrderExist === 0 && data.length > 0
          ? "bg-merah-no hover:bg-merah-hover"
          : "bg-gray-200 cursor-not-allowed"
      }`}
      disabled={deliveryOrderExist !== 0 || data.length === 0}
    >
      BUAT DO
    </button>
  </div>
)}

            </div>
          </div>
          {/* <div className="border-t border-gray-400 w-full flex-1"></div> */}
        </div>
      </div>

      {/* Table Data */}
    <div className="mt-8">
    {loading && <p>Loading...</p>}
    {error && <p className="text-red-500">{error}</p>}
    {!loading && !error && Object.keys(sortedGroupedData).length === 0 && <p>No data available</p>}

    {/* Desktop view */}
    <div className="hidden md:block">
      {Object.entries(sortedGroupedData).map(([orderNumber, orderDetails]) => (
        <div key={orderNumber} className="mb-10 odd:bg-white even:bg-[#F2DBB5] p-4 rounded-[15px] border border-gray-400">
          {/* Header Info */}
          <div className="text-center p-4">
            <h3 className="text-base lg:text-xl font-semibold">Dapur: {orderDetails[Object.keys(orderDetails)[0]][0].kitchen_name}</h3>
            <h3 className="text-base lg:text-xl font-semibold">Pemasok: {orderDetails[Object.keys(orderDetails)[0]][0].supplier_name}</h3>
            <h3 className="text-base lg:text-xl font-semibold">No. PO: {orderNumber}</h3>
          </div>

          {/* Tables per delivery date */}
          {Object.entries(orderDetails).map(([deliveryDate, items], index) => {
              const allItemsMatched = items.every((item) => item.matched);

              const tableKey = `${orderNumber}-${deliveryDate}`;
              
              // Only check items that are NOT matched
              const checkedItems = items
                .map((item, i) => {
                  const key = `${tableKey}-${i}`;
                  if (item.matched) return null; // ✅ skip matched items
              
                  const isChecked = editableRows[key]?.checked;
                  const editedQty = editableRows[key]?.edited_qty;
                  const quality =
                    rowDropdownValues[key]?.quality ||
                    tableColumnDefaults[tableKey]?.quality;
              
                  return {
                    isChecked,
                    isValid: isChecked && editedQty > 0 && !!quality,
                  };
                })
                .filter((item) => item?.isChecked); // only keep checked, unmatched rows
              
              // Check if timeliness is selected (from dropdown or matched data fallback)
              const timelinessSelected =
                rowDropdownValues[tableKey]?.timeliness ??
                tableColumnDefaults[tableKey]?.timeliness ??
                (items.some((item) => item.matched)
                  ? rateTime(filteredDataReceived, orderNumber, deliveryDate)
                  : null);
              
              // ✅ Final check
              const isReadyToSubmit =
                (!allItemsMatched && checkedItems.length > 0 && checkedItems.every((item) => item.isValid) || allItemsMatched) &&
                !!timelinessSelected;
              
            return (
              <div key={deliveryDate} className="mb-4 p-4 rounded-md" style={{ backgroundColor: generateGreyColor(index) }}>
                {/* Table */}
                <h4 className="font-bold mb-2">
                  Tanggal Pengiriman: {new Date(deliveryDate).toLocaleDateString("id-ID", { year: "numeric", month: "long", day: "2-digit" })}
                </h4>
                {/* Put your full table HTML here */}
                <table className="table-fixed w-full">
          <thead>
            <tr className="bg-white items-start">
              <th className="border-b px-4 py-2 rounded-tl-[15px]" style={{ width: "5%" }}>No</th>
              <th className="border-b px-4 py-2 text-left" style={{ width: "20%" }}>Bahan Baku</th>
              <th className="border-b px-2 py-2 text-center" >Diterima</th>
              <th className="border-b py-2 py-2 text-center" colSpan={2} >Jumlah PO</th>
              <th className="border-b px-0 py-2 text-center" style={{ width: "5%" }}>
    <div>Terima Semua</div>
    <input
  type="checkbox"
  className="form-checkbox h-5 w-5 text-blue-600"
  checked={allItemsMatched || selectAll[tableKey] || false}
  disabled={allItemsMatched}
  onChange={() => handleSelectAllChange(orderNumber, deliveryDate, items)}
/>
  </th>

              <th className="border-b px-5 py-2 text-center" style={{ width: "10%" }}>Jumlah Diterima</th>
              <th className="border-b px-5 py-2 text-center " style={{ width: "10%" }}>Selisih</th>
              
              <th className="border-b px-4 py-2 text-center " style={{ width: "15%" }}>
    Kualitas
    <div className="flex gap-4 items-center justify-center">
      <select
        value={tableColumnDefaults[tableKey]?.quality || ""}
        onChange={(e) =>
          handleColumnDefaultChange(tableKey, "quality", e.target.value)
        }
        className="px-7 py-2 border-gray-300 rounded-[25px]"
        //disabled={items.some((item) => item.matched)} // Disable if any item is matched
      >
        <option value="" disabled>Pilih Kualitas</option>
        {qualityDropdown.options.map((option) => (
          <option key={option.id} value={option.id}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  </th>
  <th className="border-b px-5 py-2 text-center rounded-tr-[15px] " style={{ width: "15%" }}>Ketepatan Waktu</th>

              {/* <th className="border-b px-10 py-2 text-center" style={{ width: "15%" }}>Aksi</th> */}
            </tr>
          </thead>
          <tbody>
            {items.map((item, idx) => {
              const rowKey = `${tableKey}-${idx}`; // Unique key for the row
              
              return (
                <tr key={rowKey} className="">
                  <td className="text-right px-5">{idx + 1}.</td>
                  <td className="px-4">{item.ingredient_name || "-"}</td>
                  <td className="text-center">
                    {/* Displaying matched status */}
                    {item.matched ? (
                      <span className="text-green-500">Sudah</span>
                    ) : (
                      <span className="text-red-500">Belum</span>
                    )}
                  </td>
                  <td className="text-right px-2">{formatNumber(item.order_qty)}</td>
                  <td className="text-left w-1/8">{item.uoq_code || "-"}</td>
                  <td className="text-center">
                    <input
                      type="checkbox"
                      className={item.matched ? "form-checkbox h-5 w-5 text-gray-600" : "form-checkbox h-5 w-5 text-blue-600"}
                      checked={
                        item.matched
                              ? true  
                              : editableRows[rowKey]?.checked || false 
                              }
                              disabled = { item.matched
                                ? "disabled"
                                : null}
                      onChange={() =>
                        handleCheckboxChange(orderNumber, deliveryDate, idx, item.order_qty, items)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={item.matched
                        ?  formatNumber(item.receivedQty)  
                        :  editableRows[rowKey]?.edited_qty !== undefined 
                        ? formatNumber(editableRows[rowKey]?.edited_qty)
                        : 0                    
                      }
                      className={item.matched ? "border bg-gray-100 rounded px-2 py-1 w-full text-right border-transparent  " : "border bg- rounded px-2 py-1 w-full text-right "}
                      onChange={(e) => {
                        const rawValue = e.target.value.replace(/\./g, "");
                        const numericValue = parseInt(rawValue, 10) || 0;
                        handleReceivedQtyChange(orderNumber, deliveryDate, idx, numericValue);
                      }}
                      disabled={item.matched
                        ? "disabled"
                        : !editableRows[rowKey]?.checked}
                    />
                  </td>
                  <td className="text-center px-5">
                    {item.matched
                        ?  item.receivedQty - (item.order_qty || 0)
                        : editableRows[rowKey]?.edited_qty === undefined
                      ? formatNumber( (editableRows[rowKey]?.edited_qty || 0) -
                      (item.order_qty || 0))
                      : formatNumber(editableRows[rowKey]?.edited_qty - item.order_qty) || "-"}
                  </td>
                  
                  <td className="text-center">
                  <select
    value={
      item.matched
        ? item.rate_quality
        : editableRows[rowKey]?.checked && editableRows[rowKey]?.edited_qty > 0
          ? rowDropdownValues[rowKey]?.quality || tableColumnDefaults[tableKey]?.quality || ""
          : rowDropdownValues[rowKey]?.quality || "" // don't fallback to column default if row is not editable
    }
    
    disabled={
      item.matched ||
      !editableRows[rowKey]?.checked ||
      editableRows[rowKey]?.edited_qty <= 0
    }
    onChange={(e) => handleDropdownChange(rowKey, "quality", e.target.value)}
    className={`px-7 py-2 border-transparent rounded-[25px] ${
      item.matched ? "bg-gray-300" : ""
    }`}
  >
    <option value="" disabled>
      Pilih Kualitas
    </option>
    {qualityDropdown.options.map((option) => (
      <option key={option.id} value={option.id}>
        {option.label}
      </option>
    ))}
  </select>

                  </td>
                  {idx === 0 && (
            <td rowSpan={items.length} className="text-center px-5">
              
              <select
    value={
      rowDropdownValues[tableKey]?.timeliness ||
      tableColumnDefaults[tableKey]?.timeliness ||
      (items.some((item) => item.matched)
        ? rateTime(filteredDataReceived, orderNumber, deliveryDate)
        : "")
    }
    onChange={(e) => handleDropdownChange(tableKey, "timeliness", e.target.value)}
    className={`px-8 mx-2 mt-2 border-transparent rounded-[25px] 
    `}
    //disabled={items.some((item) => item.matched)} // still disables if matched
    disabled={allItemsMatched}
  >
    <option value="" disabled>
      Ketepatan Waktu
    </option>
    {timelinessDropdown.options.map((option) => (
      <option key={option.id} value={option.id}>
        {option.label}
      </option>
    ))}
  </select>

            </td>
          )}
                </tr>
              );
            })}
            <tr>
              
    <td colSpan={5}></td>

    <td colSpan={5} className="text-right items-right">     
    {
    //orderNumber} - {items.some((item) => item.matched) ?  rateTime(filteredDataReceived, orderNumber, deliveryDate) : "no"
    }   

      {/* Simpan Penerimaan Button */}
      <button
                    onClick={() => handleDeliverySubmit(deliveryDate, orderNumber, items)}
  className={`px-8 py-4 mt-2 rounded-[25px] text-white ${
    allItemsMatched || !isReadyToSubmit ? "bg-gray-400 cursor-not-allowed" : "bg-merah-no hover:bg-merah-hover"
  }`}
  disabled={allItemsMatched || !isReadyToSubmit}
>
  {allItemsMatched ? "Sudah Diterima" : "Simpan Penerimaan"}
</button>


              {/* <button
                type="button"
                onClick={handlePenerimaanHarian}
                className="w-1/2 px-8 py-3 ms-4 mt-2 bg-merah-no text-white rounded-[25px] hover:bg-merah-hover uppercase"
              >
                BUAT DO
              </button> */}
    </td>
  </tr>

          </tbody>
        </table>
              </div>
            );
          })}
        </div>
      ))}
    </div>

    {/* Mobile view: make outer cards slideable */}
    <div className="block md:hidden relative w-full">   {/* Swiper Arrows */}
                    <Button
    variant="outline"
    size="icon"
    className="fixed top-1/2 left-4 z-[50] -translate-y-1/2 swiper-prev"
  >
    <ChevronLeft size={24} />
  </Button>

  <Button
    variant="outline"
    size="icon"
    className="fixed top-1/2 right-4 z-[50] -translate-y-1/2 swiper-next"
  >
    <ChevronRight size={24} />
  </Button>
            <Swiper
              spaceBetween={50}
              slidesPerView={1}
              loop={false}
              pagination={{
                clickable: true,
                renderBullet: function (index, className) {
                  return `<span class="!size-6 !text-sm !rounded-full !aspect-square !bg-white !border !border-gray-300 ${className}">${index + 1}</span>`;
                },
              }}
              navigation={{ nextEl: ".swiper-next", prevEl: ".swiper-prev" }}
              modules={[Pagination, Navigation]}
              className="max-w-full [&_.swiper-pagination]:w-fit [&_.swiper-pagination]:text-balance [&_.swiper-pagination]:space-y-2 [&_.swiper-pagination]:space-x-2 [&_.swiper-pagination]:lg:hidden [&_.swiper-slide]:mb-16 [&_.swiper-slide]:lg:mb-0"
            >
    <div className="flex space-x-4 px-2 pb-4">
                 
      {Object.entries(sortedGroupedData).map(([orderNumber, orderDetails], index) => (
        <SwiperSlide 
          key={orderNumber} 
          className={`flex-shrink-0 w-[320px] snap-center rounded-[15px] shadow-md p-4 border border-gray-300  ${index % 2 === 0 ? 'bg-white' : 'bg-[#F2DBB5]'}`}
        >
          

            {/* Header Info */}
            <div className="flex flex-col space-y-2 mb-4 text-center">
              <h3 className="text-base font-bold">Dapur: {orderDetails[Object.keys(orderDetails)[0]][0].kitchen_name}</h3>
              <h3 className="text-base font-semibold">Pemasok: {orderDetails[Object.keys(orderDetails)[0]][0].supplier_name}</h3>
              <h3 className="text-base font-semibold">No. PO: {orderNumber}</h3>
            </div>

            {/* Deliveries */}
            {Object.entries(orderDetails).map(([deliveryDate, items], index) => {

const allItemsMatched = items.every((item) => item.matched);

const tableKey = `${orderNumber}-${deliveryDate}`;

// Only check items that are NOT matched
const checkedItems = items
  .map((item, i) => {
    const key = `${tableKey}-${i}`;
    if (item.matched) return null; // ✅ skip matched items

    const isChecked = editableRows[key]?.checked;
    const editedQty = editableRows[key]?.edited_qty;
    const quality =
      rowDropdownValues[key]?.quality ||
      tableColumnDefaults[tableKey]?.quality;

    return {
      isChecked,
      isValid: isChecked && editedQty > 0 && !!quality,
    };
  })
  .filter((item) => item?.isChecked); // only keep checked, unmatched rows

// Check if timeliness is selected (from dropdown or matched data fallback)
const timelinessSelected =
  rowDropdownValues[tableKey]?.timeliness ??
  tableColumnDefaults[tableKey]?.timeliness ??
  (items.some((item) => item.matched)
    ? rateTime(filteredDataReceived, orderNumber, deliveryDate)
    : null);

// ✅ Final check
const isReadyToSubmit =
  (!allItemsMatched && checkedItems.length > 0 && checkedItems.every((item) => item.isValid) || allItemsMatched) &&
  !!timelinessSelected;

              return (
                <div key={deliveryDate} className="bg-gray-100 p-4 rounded-md">
                  <h4 className="text-sm font-semibold mb-2">
                    Tanggal: {new Date(deliveryDate).toLocaleDateString("id-ID", { year: "numeric", month: "long", day: "2-digit" })}
                  </h4>

                  {/* Group-level actions for each delivery */}
                  <div className="space-y-2 mb-4">
                    {/* Terima Semua */}
                    <div className="flex justify-between items-center">
                      <label className="font-medium text-sm">Terima Semua</label>
                      <input
  type="checkbox"
  className="form-checkbox h-5 w-5 text-blue-600"
  checked={allItemsMatched || selectAll[tableKey] || false}
  disabled={allItemsMatched}
  onChange={() => handleSelectAllChange(orderNumber, deliveryDate, items)}
/>

                    </div>

                    {/* Pilih Kualitas */}
                    <div>
                      <label className="text-sm font-medium block">Kualitas</label>
                      <select
                        value={tableColumnDefaults[tableKey]?.quality || ""}
                        onChange={(e) => handleColumnDefaultChange(tableKey, "quality", e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-[25px]"
                      >
                        <option value="" disabled>Pilih Kualitas</option>
                        {qualityDropdown.options.map((option) => (
                          <option key={option.id} value={option.id}>{option.label}</option>
                        ))}
                      </select>
                    </div>

                    {/* Ketepatan Waktu */}
                    <div>
                      <label className="text-sm font-medium block">Ketepatan Waktu</label>
                      <select
                        value={
                          rowDropdownValues[tableKey]?.timeliness ||
                          tableColumnDefaults[tableKey]?.timeliness ||
                          ""
                        }
                        onChange={(e) => handleDropdownChange(tableKey, "timeliness", e.target.value)}
                        className="w-full px-4 py-2 rounded-[25px] border-gray-300"
                        disabled={allItemsMatched}
                      >
                        <option value="" disabled>Ketepatan Waktu</option>
                        {timelinessDropdown.options.map((option) => (
                          <option key={option.id} value={option.id}>{option.label}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* List of items */}
                  <div className="space-y-2">
                    {items.map((item, idx) => {
                      const rowKey = `${tableKey}-${idx}`;
                      return (
                        <div key={rowKey} className="bg-white shadow-sm rounded-lg p-4 border border-gray-200">
                          <div className="font-semibold text-sm">{idx + 1}. {item.ingredient_name}</div>
                          <div className="text-xs text-gray-600 mb-1">
                            Diterima: <span className={item.matched ? "text-green-500" : "text-red-500"}>{item.matched ? "Sudah" : "Belum"}</span>
                          </div>
                          <div className="text-xs mb-1">
                            Jumlah PO: <strong>{formatNumber(item.order_qty)} {item.uoq_code}</strong>
                          </div>
                  <select
    value={
      item.matched
        ? item.rate_quality
        : editableRows[rowKey]?.checked && editableRows[rowKey]?.edited_qty > 0
          ? rowDropdownValues[rowKey]?.quality || tableColumnDefaults[tableKey]?.quality || ""
          : rowDropdownValues[rowKey]?.quality || "" // don't fallback to column default if row is not editable
    }
    
    disabled={
      item.matched ||
      !editableRows[rowKey]?.checked ||
      editableRows[rowKey]?.edited_qty <= 0
    }
    onChange={(e) => handleDropdownChange(rowKey, "quality", e.target.value)}
    className={`px-7 py-2 border-gray-300 rounded-[25px] text-xs ${
      item.matched ? "bg-gray-300" : ""
    }`}
  >
    <option value="" disabled>
      Pilih Kualitas
    </option>
    {qualityDropdown.options.map((option) => (
      <option key={option.id} value={option.id}>
        {option.label}
      </option>
    ))}
  </select>
                          {/* Checkbox + Input */}
                          <div className="flex items-center justify-between my-2">
                            
                            <label className="text-xs font-medium">Terima</label>
                            <input
                              type="checkbox"
                              className={item.matched ? "form-checkbox h-5 w-5 text-gray-600" : "form-checkbox h-5 w-5 text-blue-600"}
                              checked={item.matched ? true : editableRows[rowKey]?.checked || false}
                              disabled={item.matched}
                              onChange={() =>
                                handleCheckboxChange(orderNumber, deliveryDate, idx, item.order_qty, items)
                              }
                            />
                          </div>
                          {/* Input jumlah diterima */}
                          <input
                            type="text"
                            className={`w-full text-right rounded-md px-3 py-2 text-xs ${item.matched ? "bg-gray-100" : "border border-gray-300"}`}
                            value={
                              item.matched
                                ? formatNumber(item.receivedQty)
                                : editableRows[rowKey]?.edited_qty !== undefined
                                ? formatNumber(editableRows[rowKey]?.edited_qty)
                                : ""
                            }
                            onChange={(e) => {
                              const val = parseInt(e.target.value.replace(/\./g, ""), 10) || 0;
                              handleReceivedQtyChange(orderNumber, deliveryDate, idx, val);
                            }}
                            disabled={item.matched || !editableRows[rowKey]?.checked}
                          />
                          <div className="flex flex-row text-xs mb-1 justify-between">
                            <span>Selisih</span>
                  <span className="text-center px-5">
                    {item.matched
                        ?  item.receivedQty - (item.order_qty || 0)
                        : editableRows[rowKey]?.edited_qty === undefined
                      ? formatNumber( (editableRows[rowKey]?.edited_qty || 0) -
                      (item.order_qty || 0))
                      : formatNumber(editableRows[rowKey]?.edited_qty - item.order_qty) || "-"}
                  </span></div>
                        </div>
                      );
                    })}
                  </div>

                  {/* Save Button */}
                  <button
                    onClick={() => handleDeliverySubmit(deliveryDate, orderNumber, items)}
  className={`px-8 py-4 mt-2 rounded-[25px] text-white w-full ${
    allItemsMatched || !isReadyToSubmit ? "bg-gray-400 cursor-not-allowed" : "bg-merah-no hover:bg-merah-hover"
  }`}
  disabled={allItemsMatched || !isReadyToSubmit}
>
  {allItemsMatched ? "Sudah Diterima" : "Simpan Penerimaan"}
</button>

                </div>
              );
            })}
          </SwiperSlide>
        ))}
      </div>
      </Swiper>
    </div>
  </div>

    </div>
    
  );
}
